module.exports = __webpack_public_path__ + "img/cibcinsurance-logo-lg-fr.83c50aa6.png";